import React, { useState, useEffect } from "react";
import HomeFooter from "../Home/Home/HomeFooter/HomeFooter";
import HomeFact from "../Home/Home/HomeFact/HomeFact";
import HomeHeader from "../Home/Home/HomeHeader/HomeHeader";
import AboutAppoinment from "./AboutAppoinment/AboutAppoinment";
import AboutArea from "./AboutArea/AboutArea";
import HomeThreeFaq from "../HomeThree/HomeThreeFaq/HomeThreeFaq";
import { buscarServico } from "../../hooks/getService";

const SuplementacaoPreGestacional = () => {
  const [servicoData, setServicoData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const idArea = 2;
  const idServico = 8;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const data = await buscarServico(idServico);
        if (data) {
          setServicoData(data);
        } else {
          console.error("Erro ao buscar dados do serviço.");
        }
      } catch (error) {
        console.error("Erro na requisição:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [idServico]);

  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(valor);
  };

  const title = servicoData?.Nome || "Consulta Pré Concepcional";
  const descricao =
    "Nossa consulta pré-concepcional vai muito além de um simples atendimento: é uma preparação completa para a jornada da maternidade.";

  const precoAVista = servicoData?.Preco ? Number(servicoData.Preco) : 0;
  const parcela6x = servicoData?.Parcelas?.find(
    (p) => p.QuantidadeParcelas === 6
  )?.ValorParcela;
  const valorParcela6x = parcela6x ? Number(parcela6x) / 6 : 0;
  const price = servicoData
    ? `${formatarMoeda(precoAVista)} ou até 6x de ${formatarMoeda(
        valorParcela6x
      )}`
    : "Carregando preço...";

  const fatos = {
    titulo_fatos:
      "Cuidar de si é o primeiro passo para cuidar do bebê que está por vir.",
    descricao_fatos:
      "Avaliamos sua saúde de forma integral, identificando pontos que podem ser otimizados antes da gestação, com foco em equilíbrio hormonal, função metabólica e nutricional.",
    subtitulos: [
      {
        titulo:
          "Nutrição personalizada e exames estratégicos fazem parte do nosso cuidado.",
        subtitulo:
          "Solicitamos exames específicos que ajudam a entender o seu metabolismo, níveis vitamínicos, saúde da tireoide, glicemia, entre outros marcadores importantes para a fertilidade e para uma gestação saudável. Além disso, oferecemos orientações nutricionais individualizadas, que respeitam sua rotina e objetivos, preparando seu corpo para receber e nutrir uma nova vida.",
      },
      {
        titulo: "Em busca dos seus sonhos",
        subtitulo:
          "Com a orientação de especialistas, você pode ter confiança de que está dando o melhor começo possível para sua jornada rumo à maternidade.",
      },
    ],
  };

  const passos = [
    {
      titulo: "Escolha do serviço",
      descricao: "Escolha o melhor horário para você",
    },
    {
      titulo: "Recebimento da solicitação de exames laboratoriais",
      descricao: "Receba o link de atendimento",
    },
    {
      titulo: "Com resultado dos seus exames em mãos, agende a sua consulta",
      descricao: "Receba o link de atendimento",
    },
    {
      titulo: "Consulta realizada por videochamada (45 min)",
      descricao: "Aguarde o retorno",
    },
    {
      titulo: "Recebimento da suplementação de micronutrientes via WhatsApp",
      descricao: "Realize os exames",
    },
    {
      titulo: "Acompanhamento via WhatsApp por 15 dias após consulta",
      descricao: "Receba o relatório médico",
    },
  ];

  const imgUrl = "img/services/Suplementacao.png";

  if (isLoading) {
    return (
      <>
        <HomeHeader />
        <div style={{ textAlign: "center", padding: "50px" }}>
          <h2>Carregando...</h2>
        </div>
        <HomeFooter />
      </>
    );
  }

  return (
    <>
      <HomeHeader />
      <AboutArea
        title={title}
        descricao={descricao}
        price={price}
        idArea={idArea}
        idServico={idServico}
        imgUrl={imgUrl}
      />
      <HomeFact fatos={fatos} />
      <AboutAppoinment passos={passos} />
      <HomeThreeFaq />
      <HomeFooter />
    </>
  );
};

export default SuplementacaoPreGestacional;
